import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/toPromise"
import { Injectable } from "@angular/core";
import {
  Http,
  Response,
  Headers,
  RequestOptions,
  Request,
  URLSearchParams,
  ResponseContentType,
  RequestMethod
} from '@angular/http';
import * as moment from "moment";

import { AuthenticationService } from "app/services/authentication.service";

@Injectable()
export class HttpBackendService {

  private readonly _errors = new Subject<HttpBackendService.HttpError>();
  private readonly _requests = new Subject<Request>();

  constructor(
    private _http: Http,
    private _authenticationService: AuthenticationService
  ) { }

  get(url: string, params: URLSearchParams = null, authorize: boolean = true, responseAsBlob: boolean = false): Observable<Response> {
    return this.request(
      RequestMethod.Get,
      url,
      params,
      null,
      authorize,
      responseAsBlob
    );
  }

  post(url: string, body: {}, params: URLSearchParams = null, authorize: boolean = true): Observable<Response> {
    return this.request(
      RequestMethod.Post,
      url,
      params,
      body,
      authorize
    );
  }

  put(url: string, body: {}, params: URLSearchParams = null, authorize: boolean = true): Observable<Response> {
    return this.request(
      RequestMethod.Put,
      url,
      params,
      body,
      authorize
    );
  }

  patch(url: string, body: {}, params: URLSearchParams = null, authorize: boolean = true): Observable<Response> {
    return this.request(
      RequestMethod.Patch,
      url,
      params,
      body,
      authorize
    );
  }

  delete(url: string, params: URLSearchParams = null, authorize: boolean = true): Observable<Response> {
    return this.request(
      RequestMethod.Delete,
      url,
      params,
      null,
      authorize
    );
  }

  head(url: string, params: URLSearchParams = null, authorize: boolean = true): Observable<Response> {
    return this.request(
      RequestMethod.Head,
      url,
      params,
      null,
      authorize
    );
  }

  errors(): Observable<HttpBackendService.HttpError> {
    return this._errors;
  }

  requests(): Observable<Request> {
    return this._requests;
  }

  private request(method: RequestMethod, url: string, params: URLSearchParams, body: {}, authorize: boolean, responseAsBlob: boolean = false): Observable<Response> {
    let headers = new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    if (authorize)
      headers.append('Authorization', `x-user ${this._authenticationService.authenticatedUser.accessData.accessToken}`);

    let requestOptions = new RequestOptions({
      headers: headers,
      responseType: responseAsBlob ? ResponseContentType.Blob : ResponseContentType.Json,
      url: url,
      method: method,
      body: body ? body : undefined,
      params: params ? params : undefined
    });

    let request = new Request(requestOptions);

    this._requests.next(request);

    return this._http.request(request)
      .catch((error: Response | any) => {
        this._errors.next(new HttpBackendService.HttpError(url, error));
        return Observable.throw(error);
      });
  }

  public parseDate(dateString: string, isWithOffsetFormat: boolean = false): Date {

    let date = moment.utc(dateString, isWithOffsetFormat ? null : "YYYY-MM-DDTHH:mm:ssZ");
    if (!date.isValid())
      throw new SyntaxError("Date format is invalid!");

    return date.toDate();
  }
}

export namespace HttpBackendService {
  export class HttpError {
    constructor(
      readonly url: string,
      readonly error: Response | any
    ) { }
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/http-backend.service.ts